import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule} from "@angular/forms";
import {IonicModule} from "@ionic/angular";
import {ButtonModule} from "../../component/common/button/button.module";
import {LabelModule} from "../../component/common/label/label.module";
import {RadioModule} from "../../component/common/radio/radio.module";
import {RetryModule} from "../../component/common/retry/retry.module";
import {HeaderV2Module} from "../../component/common/header-v2/header-v2.module";
import {SettingsComponent} from "./settings.component";



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HeaderV2Module,
    ButtonModule,
    LabelModule,
    RadioModule,
    RetryModule,
  ],
  declarations: [SettingsComponent]
})
export class SettingsModule { }
